export default () => ({
  handler: 'relativeUrl',
  data: ({ ftpGameId }) => `/sportsbook/ftp_sports/${ftpGameId}/launch`,
});
